// Learner-facing wording, overridable per membership via the admin's
// Brand → Localization tab (funnel_membership_settings.brand_settings.lan_settings).
//
// Defaults mirror the admin's LAN_DEFAULTS. The API sends only the keys the owner
// actually changed (community.labels), so any key left blank in the admin keeps
// the default below.
export const DEFAULT_LABELS = {
  view_course_txt: "View Course",
  forbidden_txt: "Access Forbidden !",
  forbidden_sub_txt: "You don't have permission to access this content.",
  lesson_txt: "Lesson",
  about_lesson_txt: "About Lesson",
  discussion_txt: "Discussions",
  goals_txt: "Goals",
  resources_txt: "Resources",
  notes_txt: "Notes",
  complete_txt: "Complete",
  lesson_complete_txt: "Lesson is Completed",
  complete_quiz_txt: "Complete Quiz",
  mark_complete_txt: "Mark as Complete",
  download_resources_txt: "Download Resources",
  home: "Home",
};

/**
 * Build a label lookup from a membership's overrides.
 *
 * Returns `t(key, fallback)` — the owner's override when set, otherwise the
 * caller's `fallback` (the string already in the UI), otherwise the bundled
 * default, otherwise the key itself. The `fallback` matters where our wording
 * differs from the reference default (e.g. our "Downloads" vs the default
 * "Resources"): with no override we keep the current UI text, and an override
 * still wins.
 */
export function makeLabels(overrides) {
  const o = overrides && typeof overrides === "object" ? overrides : {};
  return (key, fallback) => {
    const v = o[key];
    if (typeof v === "string" && v.trim()) return v;
    if (fallback != null) return fallback;
    return DEFAULT_LABELS[key] || key;
  };
}
